import { render, staticRenderFns } from "./CustomerCorporateSummary.vue?vue&type=template&id=1aca604e"
import script from "./CustomerCorporateSummary.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateSummary.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateSummary.vue?vue&type=style&index=0&id=1aca604e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports